module.exports = __webpack_public_path__ + "static/media/despacho_blanco.4e865c53.svg";